import { stepperAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

import { ColorSchemeStruct } from '../types';

// Styles
const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(stepperAnatomy.keys);

const BaseStyles = definePartsStyle((props) => {
  const colorScheme = ColorSchemeStruct.parse(props.colorScheme);

  return {
    stepper: {
      flexGrow: 1,
    },
    step: {
      // Similar to <Button variant="primary" />
      '&[data-status="complete"] .chakra-icon': {
        color: mode('white', `${colorScheme}.950`)(props),
      },
      // Similar to <Button variant="secondary" />
      '&[data-status="active"] .chakra-icon': {
        color: mode(`${colorScheme}.800`, `${colorScheme}.100`)(props),
      },
      // Similar to <Button variant="secondary" colorScheme={gray} />
      '&[data-status="incomplete"] .chakra-icon': {
        color: mode(`gray.800`, `gray.100`)(props),
      },
    },
    title: {
      '&[data-status="active"]': { fontWeight: 'bold' },
    },
    description: {
      color: mode('gray.500', 'gray.200')(props),
    },
    indicator: {
      // Similar to <Button variant="primary" />
      '&[data-status="complete"]': {
        bgColor: mode(`${colorScheme}.500`, `${colorScheme}.200`)(props),
        borderColor: mode(`${colorScheme}.500`, `${colorScheme}.200`)(props),
      },
      // Similar to <Button variant="secondary" />
      '&[data-status="active"]': {
        borderColor: mode(`${colorScheme}.500`, `${colorScheme}.200`)(props),
      },
      // Similar to <Button variant="secondary" colorScheme={gray} />
      '&[data-status="incomplete"]': {
        borderColor: mode(`gray.200`, `gray.600`)(props),
      },
    },
    separator: {
      bgColor: mode('gray.200', 'gray.600')(props),
      '&[data-status="complete"]': {
        bgColor: mode(`${colorScheme}.500`, `${colorScheme}.200`)(props),
      },
      '&[data-orientation="horizontal"]': {
        alignSelf: 'flex-start',
        marginInlineStart: 0,
        marginTop: '1rem',
      },
    },
    icon: {},
    number: {},
  };
});

// Exports
export const Stepper = defineMultiStyleConfig({
  baseStyle: BaseStyles,
});
